import { useEffect, useState } from 'react';

import { decodeJwt } from 'src/modules/propertyDetails/utils/decodeJwt';
import { defaultLocalStorageAdapter } from 'src/shared/graphql';

interface DecodedJwt {
  data?: {
    hover_employee?: {
      can_manage_rails_admin?: boolean;
    };
  };
}
export const useIsHoverAdmin = (): boolean => {
  const [decodedToken, setDecodedToken] = useState<DecodedJwt>({});

  useEffect(() => {
    const getDecodedToken = async () => {
      const accessToken = await defaultLocalStorageAdapter.getAccessToken();

      setDecodedToken(decodeJwt(accessToken));
    };
    void getDecodedToken();
  }, []);

  return decodedToken?.data?.hover_employee?.can_manage_rails_admin || false;
};
